const authState = {
    loading: false,
    error: false,
    message: ''
};

export default authState;
